const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const loadOptions = (endpoint, connectionID) => async (search, prevOptions, {page}) => {
  await sleep(500);

  const pageSize = 100;

  try {
    const data = await endpoint(connectionID, page);
    const accounts = data?.accounts || [];
    const hasMore = accounts.length === pageSize;

    let filteredAccounts = accounts;
    if (search) {
      filteredAccounts = accounts.filter((acc) =>
        acc.name?.toLowerCase().includes(search.toLowerCase())
      );
    };

    
    const options = filteredAccounts.map((item) => ({
      value: item.id,
      label: item.name,
    }));

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      }
    };
  } catch (error) {
    console.error("Error loading accounts:", error);
    return { options: [], hasMore: false };
  }
};

export { loadOptions };
